<template>
    <b-modal lazy title-tag="h2" title="New Relationship" :visible="isOpen">
        <b-form-group label-cols="3" label="Client" label-for="client">
            <b-form-input plaintext :value="clientName"></b-form-input>
        </b-form-group>

        <b-form-group label-cols="3" label="Type" label-for="type">
            <b-form-select
                class="capitalize"
                :options="typeOptions"
                v-model="type"
                :disabled="isSaving"
            />
        </b-form-group>

        <b-form-group label-cols="3" label="Name" label-for="name">
            <vet-select
                v-if="isTypeRelatedTo"
                module="client"
                placeholder="Name (required)"
                v-model="relatedTo"
                :disabled="isSaving"
                name="patient_name"
            />
            <vet-select
                v-else
                module="patient-full-details"
                placeholder="Name (required)"
                label="fullname"
                v-model="patient"
                :disabled="isSaving"
                :clientId="clientId"
                name="patient_name"
            />
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSaving"
            >
                Cancel
            </b-button>
            <b-button-group v-if="!isSaving">
                <b-dropdown
                    v-if="!continues"
                    @click="save(false)"
                    left
                    split
                    text="Save + Done"
                    variant="primary"
                >
                    <b-dropdown-item @click="save(true)"
                        >Save + Add New</b-dropdown-item
                    >
                </b-dropdown>
                <b-dropdown
                    v-else
                    @click="save(true)"
                    left
                    split
                    text="Save + Add New"
                    variant="primary"
                >
                    <b-dropdown-item @click="save(false)"
                        >Save + Done</b-dropdown-item
                    >
                </b-dropdown>
            </b-button-group>
        </template>
    </b-modal>
</template>

<script>
import VetSelect from "@/module/commons/vet-select";
import Loader from "@/module/commons/loader";
import ClientRelationship from "@/services/client-relationship";
import EVENT from "@/constants/events";

export default {
    name: "modalRelationshipNew",
    components: {
        VetSelect,
        Loader
    },
    data() {
        return {
            isOpen: false,
            isSaving: false,
            patient: null,
            clientName: null,
            type: "7:",
            typeOptions: [],
            relatedTo: null,
            continues: false
        };
    },
    computed: {
        isTypeRelatedTo() {
            return this.type == "30:";
        },
        clientId() {
            return this.$store.state.client.client_id;
        }
    },
    watch: {
        type() {
            this.relatedTo = null;
            this.patient = null;
        }
    },
    methods: {
        async open() {
            this.isOpen = true;
            this.clientName = this.getClientFullName();
            this.typeOptions = await this.generateRelationshipTypes();
        },
        close() {
            this.isOpen = false;
        },
        getClientFullName() {
            const {
                firstname,
                lastname
            } = this.$store.state.client.client_details;

            return `${firstname} ${lastname}`.trim();
        },
        async generateRelationshipTypes() {
            const rawTypes = await ClientRelationship.getRelationshipTypes({
                filter_owner: true,
                client_relation: true
            });

            let result = [];

            for (const type of rawTypes) {
                result.push({
                    text: type.value2,
                    value: `${type.id}:`
                });
            }

            return result;
        },
        async save(addNew) {
            this.continues = addNew;
            try {
                if (this.isTypeRelatedTo) {
                    if (!this.relatedTo || this.relatedTo === "") {
                        throw new Error("Client name is required.");
                    }
                } else if (!this.patient || this.patient === "") {
                    throw new Error("Patient name is required.");
                }

                let params = {
                    pid: this.patient ? this.patient.id : "",
                    actor_id: this.$store.state.client.client_id,
                    entity_id: this.relatedTo ? this.relatedTo.id : "",
                    relation_id: this.type,
                    actor_type: this.type,
                    patient_name: this.isTypeRelatedTo
                        ? this.relatedTo.fullName
                        : this.patient.fullname
                };

                this.isSaving = true;
                const saved = await ClientRelationship.saveRelationship(params);

                if (!saved) {
                    throw new Error("Error: Unable to save relationship");
                }

                this.isSaving = false;
                this._message("Relationship saved");
                addNew ? this.resetData() : this.close();
                this.$emit("reload");
                this.$tabEvent.emit(EVENT.REFRESH_PATIENT_PROFILE);
            } catch (error) {
                this._message(error.message, "danger");
                this.isSaving = false;
            }
        },
        resetData() {
            this.patient = null;
            this.type = "7:";
            this.relatedTo = null;
        }
    }
};
</script>

<style scoped>
.capitalize {
    text-transform: capitalize;
}
</style>
